import React from "react";
import axios from "axios";
import { useState } from "react";
import GetRequest from "../Services/APIRequest";
import Loading from "../Components/Loading";
import Error from "../Components/Error";
import { Link, redirect, Navigate, useNavigate } from "react-router-dom";
import { ToastContainer, toast } from "react-toastify";
import { fakeBaseQuery } from "@reduxjs/toolkit/query";

const ReturnGoodsSummary = () => {
  const navigateurl = useNavigate();
  const [selectVal, setSelectVal] = useState("");
  const [warnData, setwarnData] = useState("");
  const distID = localStorage.getItem("distributorId");
  const boostID = localStorage.getItem("companyIdBooster");
  const parisID = localStorage.getItem("companyIdParis");
  const [inputs, setInputs] = useState({});
  const [txtOrderCommentsTextForState, setOrderCommentsText] = useState("");

  const handleChange = (event) => {
    const name = event.target.name;
    const value = event.target.value;
    setInputs((values) => ({ ...values, [name]: value }));
  };
  function setBasicDistId(inputs) {
    inputs.distributorId = distID;
  }
  const { data, error, isLoaded } = GetRequest(
    `/ReturnGoods/GetActiveReturnGoodsCart/${distID}`
  );

  if (error !== null) {
    return <Error data=" " />;
  }
  if (!isLoaded) {
    return <Loading />;
  }
  const tostDismissAll = () => toast.clearWaitingQueue();
  const notifySuccess = () =>
    toast.success("Order Submitted successfully !", {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  const notifySuccessAddChanel = () =>
    toast.success("Channel Partner added successfully!", {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  const notifySuccessItem = () =>
    toast.success("Cart Item added successfully!", {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  const notifyErrorItem = () =>
    toast.error("Cart Item count removed successfully!", {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  const notifyErrorDeleteItem = () =>
    toast.error("Cart Item removed successfully!", {
      position: "bottom-center",
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: "colored",
    });
  const modalWarnClose = () => {
    //  document.getElementById('showSubmitOrderDetailedModal').style.display = 'none';
    //  document.getElementById('showSubmitOrderDetailedModal').classList.add('hide');
    //  document.getElementById('showSubmitOrderDetailedModal').classList.remove('show');
  };

  const modalWarnCloseNoItemsInOrderCart = () => {
    document.getElementById("divModalNoItemsInOrderCart").style.display =
      "none";
    document.getElementById("divModalNoItemsInOrderCart").classList.add("hide");
    document
      .getElementById("divModalNoItemsInOrderCart")
      .classList.remove("show");
  };

  const handleCloseModalOrderIsBeingSaved = () => {
    document.getElementById("divOrderIsBeingSaved").style.display = "none";
    document.getElementById("divOrderIsBeingSaved").classList.add("hide");
    document.getElementById("divOrderIsBeingSaved").classList.remove("show");
  };

  const handleSubmitOrder = (event, chkDT) => {
    chkDT = true;
    event.preventDefault();

    if (
      data === null ||
      data.result === null ||
      data.result.orderCartLineItemDTOList === null ||
      data.result.orderCartLineItemDTOList.length === 0
    ) {
      document.getElementById("divModalNoItemsInOrderCart").style.display =
        "block";
      document
        .getElementById("divModalNoItemsInOrderCart")
        .classList.add("show");
      return;
    }

    if (chkDT == true) {
      modalWarnClose();
      const fData = {};
      fData.distributorId = parseInt(distID);
      fData.channelPartnerId = String(selectVal);
      fData.orderComments = String(txtOrderCommentsTextForState);

      document.getElementById("divOrderIsBeingSaved").style.display = "block";
      document.getElementById("divOrderIsBeingSaved").classList.add("show");

      axios
        .post(
          "https://dpapi.boosterparis.in/api/ReturnGoods/SubmitReturnGoodsOrder",
          fData,
          {
            headers: {
              "Cache-Control": "no-cache",
              "Access-Control-Allow-Origin": "*",
              Authorization: localStorage.getItem("loginToken"),
            },
          }
        )
        .then((response) => {
          handleCloseModalOrderIsBeingSaved();
          if (response.data.isSuccess === true) {
            tostDismissAll();
            notifySuccess();
            localStorage.setItem(
              "ditsCurrentOrderLineId",
              response.data.result.orderLineId
            );
            localStorage.removeItem("activeCartData");
            redirect("/ReturnGoodsDetails");
            <Navigate to="/ReturnGoodsDetails" />;
            navigateurl("/ReturnGoodsDetails", { replace: true });
          } else {
            alert(
              "Error while submitting order. - " +
              response.data.message +
              "-Error Code - " +
              response.data.errorCode
            );
          }
          modalWarnClose();
        })
        .catch((error) => {
          handleCloseModalOrderIsBeingSaved();
          console.log("Logging Error");
          console.log(error);
          alert(
            "Error while submitting order, Please try again." +
            error.code +
            "-" +
            error.response.status
          );
          tostDismissAll();
          modalWarnClose();
        });
    }
  };

  const minusItemProductCount = (event) => {
    let currValMin = event.currentTarget.nextSibling.value;
    if (parseInt(currValMin) !== 0) {
      currValMin = parseInt(currValMin) - 1;
      event.currentTarget.nextSibling.value = currValMin;
      const formData = {};
      formData.orderCartId = document.getElementById(
        "orderCartIdChangeQty"
      ).value;
      formData.orderCartLineItemId = event.currentTarget.id;
      formData.productItemId = event.currentTarget.attributes.getNamedItem(
        "data-val-productItemId"
      ).value;

      formData.quantity = currValMin;
      formData.distributorId = distID;
      axios
        .post(
          "https://dpapi.boosterparis.in/api/ReturnGoods/ChangeQuantityOfProductInReturnGoodsCart",
          formData,
          {
            headers: {
              "Cache-Control": "no-cache",
              "Access-Control-Allow-Origin": "*",
              Authorization: localStorage.getItem("loginToken"),
            },
          }
        )
        .then((response) => {
          if (response.data.isSuccess === true) {
            document.getElementById(
              `updateTotal${response.data.result.orderCartLineItem.id}`
            ).innerText = response.data.result.orderCartLineItem.totalCost;
            tostDismissAll();
            notifyErrorItem();

            if (formData.quantity === 0) {
              document
                .getElementById(`forRemove${formData.orderCartLineItemId}`)
                .classList.add("hide");
            }
          }
        })
        .catch((response) => { });
    }
  };

  const plusItemProductCount = (event) => {
    let currVal = event.currentTarget.previousSibling.value;
    currVal = parseInt(currVal) + 1;
    event.currentTarget.previousSibling.value = currVal;
    const formData = {};
    formData.orderCartId = document.getElementById(
      "orderCartIdChangeQty"
    ).value;
    formData.orderCartLineItemId = event.currentTarget.id;
    formData.productItemId = event.currentTarget.attributes.getNamedItem(
      "data-val-productItemId"
    ).value;
    formData.quantity = currVal;
    formData.distributorId = distID;
    axios
      .post(
        "https://dpapi.boosterparis.in/api/ReturnGoods/ChangeQuantityOfProductInReturnGoodsCart",
        formData,
        {
          headers: {
            "Cache-Control": "no-cache",
            "Access-Control-Allow-Origin": "*",
            Authorization: localStorage.getItem("loginToken"),
          },
        }
      )
      .then((response) => {
        if (response.data.isSuccess === true) {
          document.getElementById(
            `updateTotal${response.data.result.orderCartLineItem.id}`
          ).innerText = response.data.result.orderCartLineItem.totalCost;
          tostDismissAll();
          notifySuccessItem();
        }
        modalWarnClose();
      })
      .catch((response) => { });
  };
  const deleteCartOrderItem = (event) => {
    event.preventDefault();
    document.getElementById("orderCartItemLineIdDelete").value =
      event.currentTarget.id;
    const formDeleteItem = {};
    formDeleteItem.orderCartLineItemId = event.currentTarget.id;
    axios
      .post(
        "https://dpapi.boosterparis.in/api/ReturnGoods/RemoveProductFromReturnGoodsCart",
        formDeleteItem,
        {
          headers: {
            "Cache-Control": "no-cache",
            "Access-Control-Allow-Origin": "*",
            Authorization: localStorage.getItem("loginToken"),
          },
        }
      )
      .then((response) => {
        if (response.data.isSuccess === true) {
          const remot = document.getElementById(
            "orderCartItemLineIdDelete"
          ).value;
          document.getElementById(`forRemove${remot}`).classList.add("hide");
          tostDismissAll();
          notifyErrorDeleteItem();
        }
        modalWarnClose();
      })
      .catch((response) => { });
  };

  return (
    <div className="row">
      <div className="col-md-12">
        <div className="card noborder rmPdBor">
          <div className="card-body">
            <input type="hidden" id="orderCartItemLineIdDelete" value="" />
            <input
              type="hidden"
              id="orderCartIdChangeQty"
              value={data.result.orderCartId}
            />
            {data.result.orderCartLineItemDTOList &&
              data.result.orderCartLineItemDTOList.map((item, index) => (
                <div
                  className="row sepLn"
                  id={`forRemove${item.orderCartLineItemId}`}
                  data-state-id={item.productItemId}
                >
                  <div className="col-sm-3">
                    <p> {item.productName} </p>
                  </div>
                  <div className="col-sm-3">
                    <div className="d-flex flex-row">
                      <button
                        className="btn text-danger"
                        onClick={minusItemProductCount}
                        id={item.orderCartLineItemId}
                        data-val-productItemId={item.productItemId}
                      >
                        <i className="fa fa-minus"></i>
                      </button>
                      <input
                        name="quantity"
                        value={item.qty}
                        type="number"
                        id="OrderSummCartProductCount"
                        className="form-control qtyW50"
                        data-state-id={item.productItemId}
                        data-val-productItemId={item.productItemId}
                      />
                      <button
                        className="btn text-primary"
                        onClick={plusItemProductCount}
                        id={item.orderCartLineItemId}
                        data-val-productItemId={item.productItemId}
                      >
                        <i className="fa fa-plus"></i>
                      </button>
                    </div>
                    <span
                      className="fa fa-close deleteCartOrderItem"
                      onClick={deleteCartOrderItem}
                      id={item.orderCartLineItemId}
                      data-val-productItemId={item.productItemId}
                    ></span>
                  </div>
                </div>
              ))}
            <input
              type="hidden"
              value={data.result.orderCartId}
              id="activeOrderCartCard"
            />
            <div className="row">
              <div className="col-md-12 padBottomSubmit">
                <form onSubmit={handleSubmitOrder}>
                  <div className="row">
                    <div className="col-sm-4">
                      <div className="form-group">
                        <h6
                          for="Remarks "
                          className="form-label"
                          style={{ marginTop: "5px" }}
                        >
                          Remarks{" "}
                        </h6>
                        <textarea
                          maxLength={230}
                          className="form-control"
                          name="txtOrderCommentsText"
                          type="text"
                          id="txtOrderCommentsText"
                          value={txtOrderCommentsTextForState}
                          onChange={(e) => setOrderCommentsText(e.target.value)}
                        >
                          {" "}
                        </textarea>
                      </div>
                    </div>
                    <div className="col-sm-4">
                      <div className="form-group padBtnBto">
                        <input
                          className="btn btn-primary "
                          type="submit"
                          value="Submit Return Request"
                          id="btnSubmitOrder"
                        />
                      </div>
                    </div>
                  </div>
                  <div className="row"></div>
                </form>
              </div>
            </div>
          </div>
          <div className="modal fade" id="divOrderIsBeingSaved">
            <div className="modal-dialog ">
              <div className="modal-content">
                <div className="modal-header">
                  <h4 className="modal-title">
                    Saving Return Request is in progress
                  </h4>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    onClick={handleCloseModalOrderIsBeingSaved}
                  ></button>
                </div>
                <div className="row">
                  <div className="modal-body">
                    <div className="card card-warning">
                      <div className="card-body">
                        <div className="alert alert-info alert-dismissible">
                          Submitting Your Return Request. Please wait.
                          <br /> You will be redirected to Return Request
                          summary.
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="modal fade" id="divModalNoItemsInOrderCart">
            <div className="modal-dialog ">
              <div className="modal-content">
                <div className="modal-header">
                  <h4 className="modal-title">No Items Selected</h4>
                  <button
                    type="button"
                    className="btn-close"
                    data-bs-dismiss="modal"
                    onClick={modalWarnCloseNoItemsInOrderCart}
                  ></button>
                </div>
                <div className="row">
                  <div className="modal-body">
                    <div className="card card-warning">
                      <div className="card-header">
                        <h3 className="card-title">
                          <i className="fa fa-exclamation-triangle"></i>
                          Alerts
                        </h3>
                      </div>
                      <div className="card-body">
                        <div className="alert alert-info alert-dismissible">
                          Please select And add items to order cart.
                        </div>
                      </div>
                    </div>
                  </div>
                  <div className="modal-footer">
                    <button
                      type="button"
                      className="btn btn-secondary"
                      onClick={modalWarnCloseNoItemsInOrderCart}
                      data-bs-dismiss="modal"
                    >
                      Close
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ReturnGoodsSummary;
